import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const submitSTIA = async (data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/stia-assessment`, data);
        return response.data;
    } catch (error) {
        console.error("Error submitting STIA assessment:", error);
        throw error;
    }
};

export const getSTIA = async (userId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/stia-assessment/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching STIA assessment:", error);
        throw error;
    }
};
